import React from 'react';
import styled from 'styled-components';
import { colors } from '../../variables';

const Section = styled.section`
	background: #fff;
	border: 1px solid ${colors.grey.light};
`;

const FormSection = props => {
	const baseClassName = 'p20';
	const classNames = `${baseClassName} ${props.className}`;

	return <Section className={classNames}>{props.children}</Section>;
};

export default FormSection;



// WEBPACK FOOTER //
// ./src/components/Common/FormSection/FormSection.js